import { render, staticRenderFns } from "./layout-chat-v2.vue?vue&type=template&id=3ba5c94a"
import script from "./layout-chat-v2.vue?vue&type=script&lang=js"
export * from "./layout-chat-v2.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-v2.vue?vue&type=style&index=0&id=3ba5c94a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports